export default function ChallengesSection() {
  const challenges = [
    {
      icon: 'ri-scales-3-line',
      title: 'Probate Process Complexity',
      description: 'Navigating Texas probate laws can be confusing and time-consuming. The legal requirements, court filings, and documentation needed to transfer property ownership after someone passes away often require months of work and significant legal fees. Many heirs find themselves stuck in probate limbo, unable to sell or make decisions about the property until the process is complete.'
    },
    {
      icon: 'ri-group-line',
      title: 'Multiple Heirs Disagreements',
      description: 'When a property is inherited by multiple family members, disagreements are common. Some heirs may want to keep the property, others want to sell immediately, and some might want to rent it out. These conflicts can strain family relationships and delay important decisions. We help facilitate solutions that work for all parties involved, including buying out individual shares.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Property Repairs and Maintenance',
      description: 'Inherited homes often require significant repairs, especially if the previous owner was elderly or ill. From outdated electrical systems and plumbing issues to roof damage and foundation problems, the cost of bringing an inherited property up to market standards can be overwhelming. Many heirs don\'t have the funds or desire to invest in these repairs.'
    },
    {
      icon: 'ri-bank-line',
      title: 'Outstanding Mortgages and Liens',
      description: 'Discovering that an inherited property has an outstanding mortgage, tax liens, or other debts can be shocking. These financial obligations don\'t disappear when someone passes away—they transfer to the estate or heirs. Dealing with these debts while trying to sell the property adds another layer of complexity to an already difficult situation.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Distance and Location Issues',
      description: 'Many people who inherit El Paso properties live in other cities or states. Managing a property from hundreds or thousands of miles away is challenging and expensive. Regular maintenance, dealing with emergencies, preparing the home for sale, and coordinating with contractors becomes nearly impossible when you can\'t be there in person.'
    },
    {
      icon: 'ri-emotion-sad-line',
      title: 'Emotional Attachment and Grief',
      description: 'Making practical decisions about an inherited home while grieving is incredibly difficult. The property may hold decades of family memories, making it emotionally painful to sort through belongings, make repairs, or ultimately sell. Many heirs struggle with guilt about selling a family home, even when it\'s the most practical decision.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 rounded-full mb-6">
            <span className="text-teal-700 text-sm font-semibold">Common Challenges</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Challenges of Inheriting Property in El Paso
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Understanding the obstacles you face is the first step toward finding the right solution. Here are the most common challenges our clients encounter when dealing with inherited homes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {challenges.map((challenge, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${challenge.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">{challenge.title}</h3>
              <p className="text-gray-600 leading-relaxed">{challenge.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid lg:grid-cols-2">
            <div className="relative h-96 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/3ac8c9b4d4e428ec9fdc1cf6914ed382.jpg"
                alt="Dealing with Inherited Property Challenges"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="p-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                We Understand What You're Going Through
              </h3>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                At T-Rex Real Estate, we've helped hundreds of El Paso families overcome these exact challenges. We know that inheriting a property isn't just a financial transaction—it's an emotional journey that requires compassion, patience, and expertise.
              </p>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Our team specializes in creating customized solutions for inherited properties. Whether you're dealing with probate issues, family disagreements, property repairs, or any combination of these challenges, we have the experience and resources to help you move forward.
              </p>

              <a
                href="tel:+1-915-206-5814"
                className="inline-flex items-center px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white text-lg font-bold rounded-lg transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill mr-2"></i>
                Discuss Your Situation: (915) 206-5814
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}